<!--
  Component: DescriptionSafe

  This component creates a plain div of text, classed with 'description safe'
  for CSS formatting.

  Notes:
  - Similar behavior to Description component.
  - However, does not allow HTML-formatted text values, so it is safe to use
      with unvalidated text (e.g. from user)
-->
<template>
  <div class="description safe">{{dispOrFallbackText}}</div>
</template>

<script>
import Component from 'vue-class-component'

import Description from './Description'

@Component({
})
export default class DescriptionSafe extends Description {
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/DescriptionSafe.vue